import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  FormLabel,
  Input,
  InputLabel,
  ListItem,
  ListItemText,
  Select,
  TableBody
} from '@material-ui/core';
import ReactSelectMaterialUi from 'react-select-material-ui';
import moment from 'moment';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import {
  getGochiMenus,
  addGochiMenu,
  addGochiMenuImage
} from '../../actions/GochiMenus';
// import { getShops } from '../../actions/Shop';
import { getOptionGroups, getOptionShops } from '../../actions/Options';
import ValidationText from '../../components/atoms/ValidationText';
import listMenuChildTypes from '../../constants/MenuChildType';
import GochiMenuAddConfirmGroup from './GochiMenuAddConfirmGroup';
import { languages, languageType } from '../../constants/Language';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '100%%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  alignEnd: {
    alignSelf: 'end'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField: {
    // padding: '0px 5px 0px 5px',
    minWidth: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    // padding: '0px 5px 0px 5px',
    minWidth: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    },
    verticalAlign: 'top',
    maxWidth: 90
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    },
    verticalAlign: 'top'
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  displayFlex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  displayBlock: {
    display: 'block'
  },
  textMutiple: {
    paddingTop: '46px',
    width: '33px'
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  title: {
    fontWeight: 'bold',
    fontSize: 20
  },
  buttonsContainer: {
    margin: 15
  },
  description: {
    fontWeight: 500,
    fontSize: 12
  },
  marginTop: {
    marginTop: 15
  },
  situationPulldown: {
    maxWidth: '606px'
  },
  situationText: {
    fontSize: '0.75rem'
  },
  pulldownHeight: {
    maxHeight: '350px'
  },
  fukuokaTextPrice: {
    color: '#F50057',
    fontSize: '14px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      // account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix,
      account: state.accounts.account,
      languages
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          addGochiMenu,
          addGochiMenuImage,
          getOptionGroups,
          getOptionShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 0),
  withState('comboMenu', 'setComboMenu', 0),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscription', 'setSubscription', 0),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('price', 'setPrice', ''),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('shops', 'setShops', []),
  withState('groups', 'setGroups', []),
  withState('countChildGroups', 'updateCountChildGroups', 1),
  withState('shopNameError', 'setShopNameError', ''),
  withState('shopIdAdd', 'setShopIdAdd', 0),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('groupType', 'updateGroupType', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expirationType', 'setExpirationType', 0),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 1; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 0; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionGroups().then(data => {
        this.props.checkSession(data);
        this.props.setGroups(data.payload.list);
        this.props.updateCountChildGroups(
          data.payload.list.filter(
            item =>
              item.isAllowCreateChildMenu === 1 &&
              item.groupType.toUpperCase() === 'OTHERS'
          ).length
        );
        this.props.updateGroupType(
          data.payload.list[0] && data.payload.list[0].groupType
        );
      });
      this.props.actions.getOptionShops().then(data => {
        this.props.checkSession(data);
        this.props.setShops(data.payload.list);
      });
      if (this.props.shopId) {
        this.props.setShopIdAdd(this.props.shopId);
      }

      let dataFirst = {};
      const origilData = {
        shopIdAdd: null,
        menuChildType: null,
        comboMenu: null,
        menuLimitTotal: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        groupId: null,
        groups: null,
        shops: null,
        shopName: null,
        menuName: null,
        price: null,
        priceCalc: null,
        priceCombo: null,
        quantityRelease: null,
        quantityPromotion: null,
        promotionDescription: null,
        usageLimit: null,
        expirationType: null,
        expiration: null,
        expirationEndDate: null,
        minExpirationDate: null,
        maxExpirationDate: null,
        description: null,
        taxType: null,
        reducedTaxCheck: null,
        reducedTaxType: null,
        tagStr: null,
        tags: null,
        menuGenreId: null,
        menuGenreName: null,
        menuSituationId: [],
        menuSituationName: null,
        menuUserTargetId: [],
        menuUserTargetName: null
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    roles,
    openAddConfirm,
    updateOpenAdd,
    updateOpenAddConfirm,
    openAddProgress,
    updateOpenAddProgress,
    loading,
    updateLoading,
    isAddSuccess,
    updateIsAddSuccess,
    resultMessage,
    setResultMessage,
    menuChildType,
    setMenuChildType,
    groupId,
    groups,
    shopId,
    shopIdAdd,
    setShopIdAdd,
    shopName,
    setShopName,
    shops,
    menuName,
    setMenuName,
    comboMenu,
    menuLimitTotal,
    setMenuLimitTotal,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    usageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    reducedTaxMenuPrefix,
    shopNameError,
    setShopNameError,
    menuNameError,
    setMenuNameError,
    priceError,
    setPriceError,
    countChildGroups,
    subscripIntervalCountError,
    setSubscripIntervalCountError,
    groupType,
    setComboMenu,
    setUsageLimit,
    setExpirationType,
    setExpirationEndDate,
    quantityReleaseList,
    expirationList,
    expirationType,
    minExpirationDate,
    maxExpirationDate,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    onAddGochiMenuSuccess,
    menuGenreId,
    setMenuGenreId,
    subscriptionInterval,
    setSubscriptionInterval,
    subscriptionIntervalCount,
    setSubscriptionIntervalCount,
    subscription,
    setSubscription,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreError,
    setMenuGenreError,
    account,
    isFukuoka
  }) => {
    const errors = {
      shopNameError,
      menuNameError,
      priceError,
      priceComboError,
      subscripIntervalCountError,
      quantityReleaseError,
      quantityPromotionError,
      expirationError,
      menuGenreError
    };
    const validShopName = () => {
      const value = shopIdAdd;
      if (menuChildType !== 3 && menuChildType !== 4 && value === 0) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopIdAdd(value);
      return 0;
    };
    const validMenuName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };
    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        if (!isFukuoka) {
          setMenuGenreError('必須項目です。');
          return 1;
        }
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };
    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };
    const validSubscriptionIntervalCount = () => {
      const checkSubscription = subscription;
      if (checkSubscription === 1) {
        const valueIntervalCount = subscriptionIntervalCount;
        const valueInterval = subscriptionInterval;
        if (valueIntervalCount === '') {
          setSubscripIntervalCountError('必須項目です。');
          return 1;
        }
        if (Number(valueIntervalCount) < 1) {
          setSubscripIntervalCountError('頻度価値は1以上ご入力ください');
          return 1;
        }
        if (!/^\d+$/.test(valueIntervalCount)) {
          setSubscripIntervalCountError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueInterval === 'WEEK' && Number(valueIntervalCount) > 52) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
        if (valueInterval === 'MONTH' && Number(valueIntervalCount) > 12) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
      }
      setSubscripIntervalCountError('');
      return 0;
    };
    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };
    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };
    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '') {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };
    const validExpiration = () => {
      const value = expiration;
      if (value === '') {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const valid = () => {
      // console.log('shopId == ', shopId);
      // console.log('shopIdAdd == ', shopIdAdd);
      let errorCount = 0;

      // Menu normal
      if (comboMenu === 0) {
        errorCount =
          validShopName() +
          validMenuName() +
          validSubscriptionIntervalCount() +
          validPrice() +
          validMenuGenre();
      } else if (comboMenu === 1) {
        // Menu combo
        errorCount =
          validShopName() +
          validMenuName() +
          validPriceCombo() +
          validSubscriptionIntervalCount() +
          validQuantityRelease() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre();
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const resetPriceComboValue = () => {
      setPrice('');
      setPriceError('');
      setPriceCalc('000 (税込み)');
      setPriceCombo('');
      setQuantityRelease('');
      setQuantityPromotion('');
      setPromotionDescription('');
      setUsageLimit(0);
      setExpirationType(2);
      setExpiration('');
      setExpirationEndDate('');
    };

    const resetPulldownDefaultValue = value => {
      if (value === 3) {
        resetPriceComboValue();
        setComboMenu(0);
      }
      if ((value === 3 || value === 4) && roles.isGroup) {
        setShopIdAdd(Number(0));
      } else if (value) {
        setShopIdAdd(Number(0));
      }
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }
      console.log(excludedTaxPrice);
      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      const val =
        e.target.id !== 'reducedTax' && typeof e.target.id !== 'undefined'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };
    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };
    const setShopNameData = id => {
      shops.forEach(item => {
        if (id === item.shopId) {
          setShopName(item.shopName);
        }
      });
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType,
        groupId,
        shopId: shopIdAdd || shopId,
        shopName,
        menuName,
        price,
        priceCalc,
        description,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        menuCombo: comboMenu,
        menuLimitTotal:
          menuChildType !== 3 && comboMenu === 0 ? menuLimitTotal : undefined,
        priceCombo,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expirationType,
        minExpirationDate,
        maxExpirationDate,
        expiration,
        expirationEndDate,
        taxType,
        reducedTaxType,
        tags,
        tagStr,
        menuGenreId: isFukuoka
          ? menuGenre.find(
              genre => genre.menuGenreName.toString() === '飲食店以外'
            ).menuGenreId
          : menuGenreId,
        menuSituationIds,
        menuUserTargetIds
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const getSituationName = () => {
      const situationName = [];
      if (menuSituationIds.length) {
        menuSituationIds.forEach(id => {
          const name = menuSituation.find(
            situation => situation.menuSituationId.toString() === id.toString()
          ).menuSituationName;
          situationName.push(name);
        });
        return situationName.join(', ');
      }
      return '';
    };

    const getUserTargetName = () => {
      const userTargetName = [];
      if (menuUserTargetIds.length) {
        menuUserTargetIds.forEach(id => {
          const names = menuUserTarget.find(
            userTarget =>
              userTarget.menuUserTargetId.toString() === id.toString()
          ).name;
          userTargetName.push(names);
        });
        return userTargetName.join(', ');
      }
      return '';
    };

    const cancelAction = () => updateOpenAdd(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMenuSituationNames(getSituationName());
        setMenuUserTargetNames(getUserTargetName());
        setShopNameData(shopIdAdd);
        setMultiLangData(getCurrentData());
        updateOpenAddConfirm(true);
      }
    };
    const backAction = () => updateOpenAddConfirm(false);
    const registerAction = async () => {
      updateLoading(true);
      updateOpenAddProgress(true);
      let params = {};
      if (account.fukuokaFlag) {
        params = {
          ...multiLangData,
          shashokuOn: 1,
          gochimeshiOn: 0
        };
      } else {
        params = {
          ...multiLangData,
          shashokuOn:
            !multiLangData.menuCombo && !multiLangData.menuLimitTotal ? 1 : 0
        };
      }
      const addedMenu = await actions
        .addGochiMenu(params)
        .then(data => checkSession(data));
      if (image !== null) {
        let imageData = image;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile(
          'menu',
          addedMenu.payload.menuId,
          imageData,
          'public'
        );
        await actions
          .addGochiMenuImage(addedMenu.payload.menuId, {
            image: imagePath
          })
          .then(data => checkSession(data));
      }
      if (addedMenu.type === 'ADD_GOCHI_MENU_SUCCESS') {
        updateIsAddSuccess(true);
        onAddGochiMenuSuccess();
        setResultMessage('登録が完了しました。');
        updateLoading(false);
      } else {
        updateIsAddSuccess(false);
        setResultMessage('登録に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isAddSuccess) {
        updateOpenAdd(false);
        updateOpenAddConfirm(false);
        updateOpenAddProgress(false);
        actions.getGochiMenus(searchKey).then(data => checkSession(data));
      } else {
        updateOpenAddProgress(false);
      }
    };

    const getShopOptions = () => {
      const shopOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (parseInt(menuChildType, 10) === 2) {
        shops
          .filter(
            item =>
              item.isAllowCreateChildMenu === 1 || item.childShopFlag === 1
          )
          .forEach(shop => {
            shopOptions.push({
              label: shop.shopName,
              value: String(shop.shopId)
            });
          });
      } else if (parseInt(menuChildType, 10) === 1) {
        shops.forEach(shop => {
          shopOptions.push({
            label: shop.shopName,
            value: String(shop.shopId)
          });
        });
      }
      return shopOptions.length > 0 ? { ...shopOptions, tmpObj } : shopOptions;
    };

    // setting language
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setMenuName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuName
                ? multiLangData.otherLanguages[k].params.menuName
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
            setPromotionDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.quantityFreeDes
                ? multiLangData.otherLanguages[k].params.quantityFreeDes
                : ''
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setMenuName(multiLangData.menuName);
        setDescription(multiLangData.description);
        setPromotionDescription(multiLangData.quantityFreeDes);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    const groupDisplayLimit = account.groupDisplayLimit === 1;

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography className={classes.title} variant="h6">
            {isFukuoka ? 'コース登録' : 'メニュー登録'}
          </Typography>
        </div>

        <Select
          className={`${classes.textField} ${classes.alignEnd}`}
          value={isLanguage}
          onChange={e => {
            if (isLanguage === e.target.value) {
              return;
            }
            if (
              valid() ||
              (isLanguage !== languageType.ORIGIN && translateType === 0)
            ) {
              setLanguage(e.target.value);
            } else {
              alert('登録情報を正しく入力してください。');
            }
          }}
        >
          {languages.map(lang => (
            <MenuItem key={lang.value} value={lang.value}>
              {lang.label}
            </MenuItem>
          ))}
        </Select>
        {isLanguage !== languageType.ORIGIN && (
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.formInput}>
              <RadioGroup
                value={translateType}
                onChange={e => {
                  setTranslateType(parseInt(e.target.value, 10));
                }}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" />}
                  label="GG翻訳を選択"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label="自分で文章入力"
                />
              </RadioGroup>
            </Typography>
          </ListItem>
        )}

        <Table className={classes.editTable}>
          <TableBody>
            {(roles.isSecretariat ||
              roles.isChildShop ||
              roles.isGroup ||
              roles.isChildGroup) && (
              <>
                {isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <FormLabel className={classes.description}>
                        {isFukuoka ? 'コース種別*' : 'メニュー種別'}
                      </FormLabel>
                      <RadioGroup
                        value={menuChildType}
                        onChange={e => {
                          setMenuChildType(parseInt(e.target.value, 10));
                          resetPulldownDefaultValue(
                            parseInt(e.target.value, 10)
                          );
                        }}
                      >
                        {isFukuoka
                          ? listMenuChildTypes
                              .filter(item => {
                                return item.id === 1 || item.id === 4;
                              })
                              .map(item => {
                                let nameRadio = '';
                                if (item.id === 1) {
                                  nameRadio = '通常（教室別）';
                                } else if (item.id === 4) {
                                  nameRadio = 'グループ共通';
                                }
                                return (
                                  <FormControlLabel
                                    value={item.id}
                                    label={nameRadio}
                                    disabled={
                                      (item.id === 4 &&
                                        groupType === 'OTHERS') ||
                                      (item.id === 1 && groupDisplayLimit)
                                    }
                                    control={<Radio color="primary" />}
                                  />
                                );
                              })
                          : listMenuChildTypes
                              .filter(item => {
                                return item.id !== -1;
                              })
                              .map(item => (
                                <FormControlLabel
                                  value={item.id}
                                  disabled={
                                    (item.id === 3 && countChildGroups === 0) ||
                                    (item.id === 4 && groupType === 'OTHERS') ||
                                    (item.id === 1 && groupDisplayLimit) ||
                                    (item.id === 2 && groupDisplayLimit) ||
                                    item.id === 5
                                  }
                                  label={item.name}
                                  control={<Radio color="primary" />}
                                />
                              ))}
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                )}
                {parseInt(menuChildType, 10) !== 3 &&
                  parseInt(menuChildType, 10) !== 4 &&
                  parseInt(menuChildType, 10) !== 5 &&
                  isLanguage === languageType.ORIGIN && (
                    <TableRow>
                      <TableCell className={classes.colLeft}>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <ReactSelectMaterialUi
                          required
                          label={isFukuoka ? '教室名*' : '店舗名*'}
                          className={classes.textField}
                          defaultValue={String(shopId)}
                          value={String(shopIdAdd)}
                          options={getShopOptions()}
                          onChange={v => {
                            setShopIdAdd(Number(v));
                          }}
                          SelectProps={{
                            isClearable: true,
                            msgNoOptionsMatchFilter:
                              '名前が部分一致する店舗がありません'
                          }}
                          onBlur={validShopName}
                        />
                        <ValidationText message={errors.shopNameError} />
                      </TableCell>
                    </TableRow>
                  )}
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      required
                      label={isFukuoka ? 'コース名' : 'メニュー名'}
                      defaultValue={menuName}
                      className={classes.textField}
                      onChange={e => {
                        setMenuName(e.target.value);
                      }}
                      onBlur={validMenuName}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={menuName}
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 250 : 1000
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                    {(isLanguage === languageType.ORIGIN ||
                      translateType === 1) && (
                      <ValidationText message={errors.menuNameError} />
                    )}
                  </TableCell>
                </TableRow>
                {parseInt(menuChildType, 10) !== 3 &&
                  parseInt(menuChildType, 10) !== 5 &&
                  isLanguage === languageType.ORIGIN &&
                  !isFukuoka && (
                    <TableRow>
                      <TableCell className={classes.colLeft}>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <RadioGroup
                          row
                          value={comboMenu}
                          onChange={e => {
                            setComboMenu(parseInt(e.target.value, 10));
                            resetPriceComboValue();
                          }}
                        >
                          <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="回数券"
                          />
                          <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="普通"
                          />
                        </RadioGroup>
                      </TableCell>
                      <TableCell className={classes.width100} />
                    </TableRow>
                  )}
                {menuChildType !== 3 &&
                  menuChildType !== 5 &&
                  comboMenu === 0 &&
                  isLanguage === languageType.ORIGIN &&
                  !isFukuoka && (
                    <TableRow>
                      <TableCell className={classes.colLeft}>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <Typography>利用方法</Typography>
                        <RadioGroup
                          row
                          value={menuLimitTotal}
                          onChange={e => {
                            setMenuLimitTotal(parseInt(e.target.value, 10));
                          }}
                        >
                          <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="一枚単位利用"
                          />
                          <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="一円単位利用"
                          />
                        </RadioGroup>
                      </TableCell>
                      <TableCell className={classes.width100} />
                    </TableRow>
                  )}
                {enabledStripeBilling === true && menuChildType !== 5 && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <Typography className={classes.description}>
                        サブスクチケット利用する
                      </Typography>
                      <RadioGroup
                        row
                        value={subscription}
                        onChange={e => {
                          setSubscription(parseInt(e.target.value, 10));
                        }}
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="利用する"
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="利用しない"
                        />
                      </RadioGroup>
                    </TableCell>
                    <TableCell className={classes.width100} />
                  </TableRow>
                )}
                {subscription === 1 && enabledStripeBilling === true && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <Typography className={classes.description}>
                        購入頻度設定
                      </Typography>
                      <div className={classes.displayFlex}>
                        <div className={classes.displayBlock}>
                          <TextField
                            id="subscriptionIntervalCount"
                            required
                            label="頻度"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={subscriptionIntervalCount}
                            onChange={e => {
                              setSubscriptionIntervalCount(
                                e.target.value.trim()
                              );
                            }}
                            onBlur={validSubscriptionIntervalCount}
                          />
                        </div>
                        <div className={classes.displayBlock}>
                          <TextField
                            id="subscriptionInterval"
                            name="subscriptionInterval"
                            select
                            required
                            label="単位"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={subscriptionInterval}
                            InputProps={{
                              shrink: true
                            }}
                            onChange={e => {
                              setSubscriptionInterval(e.target.value.trim());
                            }}
                          >
                            <MenuItem key="0" value="WEEK">
                              週間
                            </MenuItem>
                            <MenuItem key="1" value="MONTH">
                              ヶ月
                            </MenuItem>
                          </TextField>
                        </div>
                        <div className={classes.textMutiple}>1回</div>
                      </div>
                      <ValidationText
                        message={errors.subscripIntervalCountError}
                      />
                    </TableCell>
                    <TableCell className={classes.width100} />
                  </TableRow>
                )}
                {comboMenu === 1 && (
                  <>
                    {isLanguage === languageType.ORIGIN && (
                      <TableRow>
                        <TableCell className={classes.colLeft}>
                          <RequiredButton />
                        </TableCell>
                        <TableCell className={classes.colRight}>
                          <FormLabel className={classes.description}>
                            単価 × 発行枚数
                          </FormLabel>
                          <div className={classes.displayFlex}>
                            <div className={classes.displayBlock}>
                              <TextField
                                id="priceCombo"
                                required
                                label="単価"
                                className={classes.textFieldPriceCombo}
                                margin="normal"
                                value={priceCombo}
                                onChange={e => {
                                  setPriceCombo(e.target.value.trim());
                                  calcPrice(e);
                                }}
                                onBlur={validPriceCombo}
                              />
                              <ValidationText
                                message={errors.priceComboError}
                              />
                            </div>
                            {/* <div className={classes.priceCalc}>{priceCalc}</div> */}
                            <div className={classes.textMutiple}>円 x</div>
                            <div className={classes.displayBlock}>
                              <TextField
                                id="quantityRelease"
                                name="quantityRelease"
                                select
                                required
                                label="発行枚数"
                                className={classes.textFieldPriceCombo}
                                margin="normal"
                                value={quantityRelease}
                                InputProps={{
                                  shrink: true
                                }}
                                onChange={e => {
                                  setQuantityRelease(e.target.value.trim());
                                  calcPrice(e);
                                }}
                                onBlur={validQuantityRelease}
                              >
                                {quantityReleaseList.map(item => {
                                  return (
                                    <MenuItem
                                      key={item.value}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                              <ValidationText
                                message={errors.quantityReleaseError}
                              />
                            </div>
                            <div className={classes.textMutiple}>枚</div>
                          </div>
                        </TableCell>
                        <TableCell className={classes.width100} />
                      </TableRow>
                    )}
                    {isLanguage === languageType.ORIGIN && (
                      <TableRow>
                        <TableCell className={classes.colLeft}>
                          <AnyButton />
                        </TableCell>
                        <TableCell className={classes.colRight}>
                          <TextField
                            id="quantityPromotion"
                            name="quantityPromotion"
                            select
                            isClearable
                            label="付与無料枚数"
                            className={classes.textField}
                            margin="normal"
                            value={quantityPromotion}
                            InputProps={{
                              shrink: true
                            }}
                            onChange={e => {
                              setQuantityPromotion(e.target.value);
                            }}
                            onBlur={validQuantityPromotion}
                          >
                            {quantityReleaseList.map(item => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                          <ValidationText
                            message={errors.quantityPromotionError}
                          />
                        </TableCell>
                        <TableCell className={classes.width100} />
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell className={classes.colLeft}>
                        <AnyButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <TextField
                          label="おまけ"
                          multiline
                          rows="4"
                          className={classes.textFieldLong}
                          margin="normal"
                          onChange={e => {
                            setPromotionDescription(e.target.value);
                          }}
                          inputProps={{
                            maxLength:
                              isLanguage === languageType.ORIGIN ? 1000 : 2500
                          }}
                          value={promotionDescription}
                          disabled={
                            isLanguage !== languageType.ORIGIN &&
                            translateType === 0
                          }
                        />
                      </TableCell>
                      <TableCell className={classes.width100} />
                    </TableRow>
                    {isLanguage === languageType.ORIGIN && (
                      <TableRow>
                        <TableCell className={classes.colLeft}>
                          <AnyButton />
                        </TableCell>
                        <TableCell className={classes.colRight}>
                          <RadioGroup
                            row
                            value={usageLimit}
                            onChange={e => {
                              setUsageLimit(parseInt(e.target.value, 10));
                            }}
                          >
                            <FormControlLabel
                              value={1}
                              control={<Radio color="primary" />}
                              label="1日1枚"
                            />
                            <FormControlLabel
                              value={0}
                              control={<Radio color="primary" />}
                              label="なし"
                            />
                          </RadioGroup>
                        </TableCell>
                        <TableCell className={classes.width100} />
                      </TableRow>
                    )}
                    {isLanguage === languageType.ORIGIN && (
                      <TableRow>
                        <TableCell className={classes.colLeft}>
                          <AnyButton />
                        </TableCell>
                        <TableCell className={classes.colRight}>
                          <Typography className={classes.description}>
                            利用期間
                          </Typography>
                          <RadioGroup
                            row
                            value={expirationType}
                            onChange={e => {
                              setExpirationType(parseInt(e.target.value, 10));
                              resetExpirationValue();
                            }}
                          >
                            <FormControlLabel
                              value={0}
                              control={<Radio color="primary" />}
                              label="期間指定"
                            />
                            <FormControlLabel
                              value={1}
                              control={<Radio color="primary" />}
                              label="期限指定"
                            />
                            <FormControlLabel
                              value={2}
                              control={<Radio color="primary" />}
                              label="指定しない"
                            />
                          </RadioGroup>
                          {expirationType === 0 && (
                            <TextField
                              id="expiration"
                              name="expiration"
                              select
                              label="利用期間"
                              className={classes.textField}
                              margin="normal"
                              value={expiration}
                              InputProps={{
                                shrink: true
                              }}
                              onChange={e => {
                                setExpiration(e.target.value);
                              }}
                              // variant="filled"
                            >
                              {expirationList.map(item => {
                                return (
                                  <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          )}
                          {expirationType === 1 && (
                            <TextField
                              label="終了"
                              type="date"
                              className={classes.textField}
                              margin="normal"
                              InputLabelProps={{
                                shrink: true
                              }}
                              value={expirationEndDate}
                              inputProps={{
                                min: minExpirationDate,
                                max: maxExpirationDate
                              }}
                              onChange={e => {
                                setExpirationEndDate(e.target.value);
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell className={classes.width100} />
                      </TableRow>
                    )}
                  </>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <TextField
                        id="price"
                        disabled={comboMenu === 1}
                        required
                        label={isFukuoka ? '金額' : '価格'}
                        defaultValue={price}
                        className={classes.textField}
                        value={price}
                        onChange={e => {
                          setPrice(e.target.value.trim());
                          calcPrice(e);
                        }}
                        onBlur={validPrice}
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      <ValidationText message={errors.priceError} />
                      <div className={classes.priceCalc}>{priceCalc}</div>
                      {isFukuoka && (
                        <div className={classes.fukuokaTextPrice}>
                          ※10,000円以内の金額を入力してください
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <div>
                        <TextField
                          id="taxType"
                          name="taxType"
                          select
                          label={isFukuoka ? '税区分' : '税区分・寄付'}
                          className={classes.textField}
                          value={taxType}
                          onChange={e => {
                            setTaxType(e.target.value.trim());
                            calcPrice(e);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          fullWidth
                        >
                          {isFukuoka
                            ? taxTypes
                                .filter(group => {
                                  return group.id !== 'DONATION';
                                })
                                .map(group => {
                                  return (
                                    <MenuItem key={group.id} value={group.id}>
                                      {group.name}
                                    </MenuItem>
                                  );
                                })
                            : taxTypes.map(group => {
                                return (
                                  <MenuItem key={group.id} value={group.id}>
                                    {group.name}
                                  </MenuItem>
                                );
                              })}
                        </TextField>
                      </div>
                      {!isFukuoka && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              id="reducedTax"
                              checked={reducedTaxCheck}
                            />
                          }
                          label="軽減税率対象"
                          onChange={e => {
                            setReducedTaxCheck(e.target.checked);
                            convertReducedTax(e.target.checked);
                            calcPrice(e);
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && !isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <TextField
                        required
                        select
                        label="ジャンル"
                        className={classes.textField}
                        margin="normal"
                        value={menuGenreId}
                        onChange={e => {
                          setMenuGenreId(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        onBlur={validMenuGenre}
                      >
                        {menuGenre &&
                          menuGenre.map(item => {
                            return (
                              <MenuItem
                                key={item.menuGenreId}
                                value={item.menuGenreId}
                              >
                                {item.menuGenreName}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                      <ValidationText message={errors.menuGenreError} />
                    </TableCell>
                    <TableCell className={classes.width100} />
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && !isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <AnyButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <InputLabel
                        id="situation-label"
                        className={classes.situationText}
                      >
                        シチュエーション
                      </InputLabel>
                      <Select
                        labelId="situation-label"
                        multiple
                        value={menuSituationIds}
                        onChange={e => setmenuSituationIds(e.target.value)}
                        input={<Input />}
                        renderValue={() => getSituationName()}
                        className={
                          (classes.textFieldLong, classes.situationPulldown)
                        }
                        MenuProps={{
                          classes: { paper: classes.pulldownHeight },
                          getContentAnchorEl: null
                        }}
                        fullWidth
                      >
                        {menuSituation &&
                          menuSituation.map(situation => (
                            <MenuItem
                              key={situation.menuSituationId}
                              value={situation.menuSituationId}
                            >
                              <Checkbox
                                checked={
                                  menuSituationIds.indexOf(
                                    situation.menuSituationId
                                  ) > -1
                                }
                              />
                              <ListItemText
                                primary={situation.menuSituationName}
                              />
                            </MenuItem>
                          ))}
                      </Select>
                    </TableCell>
                    <TableCell className={classes.width100} />
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && !isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <AnyButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <InputLabel
                        id="user-target-label"
                        className={classes.situationText}
                      >
                        贈り相手
                      </InputLabel>
                      <Select
                        labelId="user-target-label"
                        multiple
                        value={menuUserTargetIds}
                        onChange={e => setmenuUserTargetIds(e.target.value)}
                        input={<Input />}
                        renderValue={() => getUserTargetName()}
                        className={
                          (classes.textFieldLong, classes.situationPulldown)
                        }
                        MenuProps={{
                          classes: { paper: classes.pulldownHeight },
                          getContentAnchorEl: null
                        }}
                        fullWidth
                      >
                        {menuUserTarget &&
                          menuUserTarget.map(target => (
                            <MenuItem
                              key={target.menuUserTargetId}
                              value={target.menuUserTargetId}
                            >
                              <Checkbox
                                checked={
                                  menuUserTargetIds.indexOf(
                                    target.menuUserTargetId
                                  ) > -1
                                }
                              />
                              <ListItemText primary={target.name} />
                            </MenuItem>
                          ))}
                      </Select>
                    </TableCell>
                    <TableCell className={classes.width100} />
                  </TableRow>
                )}
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="説明"
                      multiline
                      rows="4"
                      defaultValue={description}
                      className={classes.textFieldLong}
                      onChange={e => {
                        setDescription(e.target.value);
                      }}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 1000 : 2500
                      }}
                      value={description}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                  </TableCell>
                </TableRow>
                {isLanguage === languageType.ORIGIN && !isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <AnyButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <TextField
                        label="タグ"
                        defaultValue={tagStr}
                        className={classes.textFieldLong}
                        onChange={e => {
                          setTagStr(e.target.value);
                          splitTagStr(e.target.value);
                        }}
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      <div className={classes.marginTop}>
                        #おすすめ #おふくろの味 #学生に ＃ガッツリ
                        などメニューの特徴を表すタグを記載できます。
                      </div>
                    </TableCell>
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <FormLabel className={classes.description}>
                        画像
                      </FormLabel>
                      <FileUpload
                        label="image"
                        file={image}
                        setFile={setImage}
                        previewImage={previewImage}
                        setPreviewImage={setPreviewImage}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCellBorderNone} />
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
        <div className={classes.buttonsContainer}>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddConfirm} className={classes.modal}>
          <GochiMenuAddConfirmGroup
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            openAddProgress={openAddProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            roles={roles}
            groups={groups}
            currentLanguage={isLanguage}
            setIsLanguage={setIsLanguage}
            shopName={shopName}
            menuGenreName={menuGenreName}
            menuSituationNames={menuSituationNames}
            menuUserTargetNames={menuUserTargetNames}
            previewImage={previewImage}
            isFukuoka={isFukuoka}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
